module.exports = __webpack_public_path__ + "static/media/7sinif.yt.mat.4.148e90ad.jpg";